import ChevronIcon from './ChevronIcon.jsx';

const SectionLabel = ({ children }) => (
  <div className="ar-eyebrow">
    <ChevronIcon />
    {children}
  </div>
);

export default SectionLabel;
